import Component from 'vue-class-component';
import EdHomeworkTeacherSectionPersonItem from '../ed-homework-teacher-section-person-item/ed-homework-teacher-section-person-item.vue';
import EdHomeworkFeedback from '../ed-homework-feedback/ed-homework-feedback.vue';
import EdHomeworkGrade from '../ed-homework-grade/ed-homework-grade.vue';
import EdListHomeworkLoading from '../ed-list-homework-loading/ed-list-homework-loading.vue';
import { WidgetTeacherSectionList } from '@/homework/models/widget-teacher-section-list.model';
import { Status } from '@/models/status.model';
import {
  HOMEWORKS_EVENTS,
} from '@/homework/values/homeworks.values';
import Course from '@/content/models/course.model';
import {Mixins, Prop} from 'vue-property-decorator';
import {CourseToolsMixin} from '@/courses/mixins/course-tools.mixin';

@Component({
  components: {
    EdHomeworkTeacherSectionPersonItem,
    EdHomeworkFeedback,
    EdHomeworkGrade,
    EdListHomeworkLoading
  },
})
export default class EdHomeworkTeacherSectionPersonCourseViewer extends Mixins(CourseToolsMixin) {

  public personsStatus: Status = new Status();
  public morePersonsStatus: Status = new Status();
  public currentHomework: any = null;
  public isSaving: boolean = false;
  @Prop() readonly courseId: number;
  @Prop({default: null}) readonly classId: number;

  get sectionSelected() {
    let sectionSelected = this.course.viewer.sectionSelected;
    if(!sectionSelected) {
      return null;
    }
    let section = new WidgetTeacherSectionList({
      id: sectionSelected.sectionId,
      name: sectionSelected.name,
      classId: this.classId,
      courseId: this.courseId,
      resolved: sectionSelected.resolved,
    });
    section.users = this.course.sectionCompletedTask.users;
    return section;
  }

  get showSeeMore() {
    return this.course.sectionCompletedTask ? this.course.sectionCompletedTask.users.more : false;
  }

  get sections() {
    const sections = this.course.sectionCompletedTask?.users.content || [];
    if( sections.length ) {
      this.personsStatus.setLoad();
    } else {
      this.personsStatus.setEmpty();
    } 
    return sections;
  }

  get course(): Course {
    return this.getCourseFromStore({courseId: this.courseId , classId: this.classId });
  }

  getMorePersons() {
    this.getCompletedTaskByStudent(this.sectionSelected.users.page + 1);
  }

  updateCompletedTaskByStudent() {
    this.getCompletedTaskByStudent();
  }

  private getCompletedTaskByStudent(page = 0) {
    this.$Courses.Store.getCompletedTaskByStudentA({
      ...this.sectionSelected, sectionId: this.sectionSelected.id, page: page
    });
  }

  created() {
    this.$edEventBus.$on(HOMEWORKS_EVENTS.REALOAD_TEACHER_HOMEWORKS_FEEDBACK, this.updateCompletedTaskByStudent);
  }

  mounted() {
    this.personsStatus.setLoad();
    this.$Courses.Store.setShowSectionPersonCourseViewer(true);
  }

  beforeDestroy() {
    this.$edEventBus.$off(HOMEWORKS_EVENTS.REALOAD_TEACHER_HOMEWORKS_FEEDBACK, this.updateCompletedTaskByStudent);
    this.$Courses.Store.setShowSectionPersonCourseViewer(false);
  }


}